import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconStarStyle0 = gravityIconIndividualCss;

const GravityIconStar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ae6356a30a8c6790b2fa9f80bbcc56f926cdf51e', color: this.color, size: this.size }, h("svg", { key: 'b49b0dfcfcdc7968ddf8feb7505fdf7680e50788', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8f5f408f570cfbc1da57f288feb6448d81eb63ed', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.004 5.905 1.526 3.86 3.87.352-3.158 2.79 1.03 3.555-3.268-2.14-3.267 2.14 1.03-3.556-3.163-2.79 3.875-.351 1.526-3.86Zm0-2.905c-.204 0-.346.151-.488.516L8.54 8.51l-4.892.445C3.187 9 3 9.116 3 9.364c0 .178.089.32.329.525l3.922 3.458-1.432 4.942c-.124.453-.017.711.294.711a.852.852 0 0 0 .426-.16l4.465-2.924 4.465 2.924a.88.88 0 0 0 .427.16c.32 0 .426-.267.293-.711l-1.432-4.942 3.914-3.458c.24-.205.329-.347.329-.525 0-.248-.187-.364-.649-.408l-4.883-.445-1.974-4.995c-.152-.374-.285-.516-.49-.516Z", fill: "currentColor" }))));
    }
};
GravityIconStar.style = GravityIconStarStyle0;

export { GravityIconStar as gravity_icon_star };

//# sourceMappingURL=gravity-icon-star.entry.js.map